<template>
  <OnboardingLayout
    title="Outright Sale Customers starts here!"
    :imageDescription="welcomeText"
    description="Join the thousands of Arnergy users all over Africa who are enjoying uninterrupted power supply with our solar solution."
    @onButtonClick="handleContinue"
    :canContinue="canContinue"
  >
    <template slot="subtext">This is an OS customer</template>
    <div class="choose-package">
      <!-- Display this if It's IPP -->
      <div class="choice-type">Choose a device type</div>

      <div v-if="showLoading">
        <vue-skeleton-loader noOfCell="3"></vue-skeleton-loader>
      </div>

      <div v-if="!showLoading && products.length < 1">
        there are have 0 products onboarded, kindly contact admin
      </div>

      <div class="package">
        <div v-for="item in products" :key="item.id">
          <onboarding-select-button
            :ID="item.id"
            :title="item.name"
            :description="item.productDescription"
            :image="
              item.url_image
                ? item.url_image
                : require('@/assets/img/arnergy-5000.png')
            "
            :isActive="activeProduct && activeProduct.id == item.id"
            @setActive="setActiveProduct(item)"
          />
        </div>
      </div>
    </div>
  </OnboardingLayout>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import MoneyFormat from "vue-money-format";
import ButtonOnboardingPackage from "@/components/pages/kitchen/ButtonOnboardingPackage";
import OnboardingSelectButton from "@/components/pages/kitchen/OnboardingSelectButton";
import SideIndicator from "@/components/pages/kitchen/Onboarding/SideIndicator.vue";
import ModalCalculate from "@/components/pages/kitchen/Onboarding/ModalCalculate";
import ModalMain from "@/components/pages/kitchen/Onboarding/ModalMain.vue";

import OnboardingTopBar from "@/components/OnboardingTopBar.vue";
import OnboardingButton from "@/components/OnboardingButton.vue";
import OnboardingLayout from "@/components/layouts/onboarding-layout.vue";
import OnboardingService from "@/services/onboarding.js";

import VueSkeletonLoader from "@/components/SkeletonLoader.vue";

export default {
  computed: {
    ...mapGetters(["getUserSession"])
  },
  components: {
    OnboardingLayout,
    ButtonOnboardingPackage,
    OnboardingSelectButton,
    SideIndicator,
    ModalCalculate,
    ModalMain,
    MoneyFormat,
    OnboardingTopBar,
    OnboardingButton,
    VueSkeletonLoader
  },
  data() {
    return {
      welcomeText: "Begin your OS customer journey here",
      activeIndex: 0,
      showLoading: false,
      canContinue: false,
      showIpp: false,
      showStandard: false,
      showCustomerType: true,
      nextPageName: "OnboardOSPaymentSummary",
      activePackageType: {},
      activeCustomerType: {},
      activeProduct: {},
      products: []
    };
  },
  methods: {
    async fetchProducts() {
      try {
        this.showLoading = true;
        const HTTP = this.$httpUtils.FASTHTTP;
        let res = await HTTP.get("/product/products", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("appUserToken")}`
          }
        });

        // parse for "arnergy-select" use
        return res.data
          .map(item => {
            return {
              id: item.id,
              name: item.producttype,
              productDescription: item.productdescription,
              amountOS: item.amountos,
              monthlyAmountLO: item.monthlyamountlo,
              tenure: item.tenurelo,
              url_image: item.image_url,
              maintenance_fee: item.maintenance_fee,
              installation_cost: item.installation_cost,
              equipment_cost: item.equipment_cost,
              logistics_cost: item.logistics_cost
            };
          })
          .sort((a, b) => {
            return a.name > b.name ? 1 : -1;
          });
      } catch (error) {
        console.log("error fetching onboarding products >>>>>", error);
      } finally {
        this.showLoading = false;
      }
    },
    setActiveProduct(item) {
      this.welcomeText = item.productDescription;
      this.activeProduct = item;
      this.canContinue = true;
    },
    updateGlobalState() {
      const onboardingCustomerState = this.$store.state.onboardingCustomerState;
      this.$store.commit("saveOnboardingCustomerState", {
        ...onboardingCustomerState,
        selectedProduct: this.activeProduct
      });
    },
    handleContinue() {
      this.updateGlobalState();
      OnboardingService.updateDbData({
        currentPageName: this.nextPageName,
        product_id: this.activeProduct.id
      });
      this.navTo(this.nextPageName);
    }
  },
  async mounted() {
    this.products = await this.fetchProducts();
  }
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  width: 100%;
  padding: 0rem 14rem;
  font-family: "DM Sans";
  background: #ffffff;

@media screen and (max-width: 600px) {
  padding: 0rem 2rem;
  flex-direction: column-reverse;
}
}

.choose-package {
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}

.button {
  border: 1px solid #0892d0;
  border-radius: 5px;
  padding: 7px 10px;
}

.welcome {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 39px;
  color: #0892d0;
  margin-bottom: 2.1rem;
}

.subtext {
  font-family: "DM Sans";
  max-width: 58.1rem;
  width: 100%;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #727272;
  margin-bottom: 2.7rem;
}

.choice-type {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 2.7rem;
  color: #fe7a11;
}

.boxes {
  display: flex;
  margin-bottom: 2.7rem;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}

.package {
  display: grid !important;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 20px;
  margin-bottom: 2.7rem;
}

.right-image {
  display: flex;
  flex-direction: column;
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.man-woman {
  margin-bottom: 9rem;
}

.continue {
  display: block;
  margin-left: auto;
  margin-right: 0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/standard/os/index.vue